export default __webpack_public_path__ + "static/media/lateral_raise_end.01496ecd.svg";